import React from 'react'
import { observer } from 'mobx-react'
import StaffingSearchViewModel from 'admin/staffing/components/StaffingTable/StaffingSearchViewModel'
import styles from './WorkspacePostingCount.sass'

interface WorkspacePostingCountProps {
  vm: StaffingSearchViewModel
}

export default observer(function WorkspacePostingCount({
  vm,
}: WorkspacePostingCountProps) {
  const totalPostings = vm.workspacePostings.length

  return (
    <div className={styles.postingCountContainer}>
      All postings
      <span className={styles.postingCount}>({totalPostings ?? 0})</span>
    </div>
  )
})
